/** Компонента редактирование значений литеральных без задания языка. 
 * Используется для заполнения свойств, которые не должны иметь отдельные языковые константы.
 * 
 * Например, http://www.w3.org/ns/adms#supportedSchema, http://www.w3.org/ns/dcat#accessURL 
 * 
 * Формирует редактор литерального значения
 * с кнопками:
 * - "Редактировать" значение. По кнопке перезодит в режим редактирования.
 * - "X" отмена редактирования. По кнопке возвращается предудыщее значение
 * - "ОК" - по кнопке происходит созранение введённого значения
 *  По Ok создаётся удаляются все триплеты с заданным субъектом и предекатом. А затем
 *     создаётся новый триплет с данными.
*/
import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux';
import { Tooltip, Button, Form, Modal } from 'antd';
import { EditOutlined, CloseOutlined, CheckOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { RdfTriplet } from '../../redux';
import moment from 'moment';

const ButtonGroup = Button.Group;
const { confirm } = Modal;

/** Преобразовать данные из формы в строковые значения  */
const valueToString = (value, predicat) =>{
  //проверка, что moment см. https://stackoverflow.com/questions/36457220/how-to-test-if-a-variable-is-a-moment-js-object
  if (value instanceof moment){
    return value.format("yyyy-MM-DD")
  }
  if (["http://www.w3.org/ns/dcat#downloadURL", "http://www.w3.org/ns/dcat#accessURL"].includes(predicat)){
    return ""+value;
  }
  return ""+value;
}

/** Получение значение из списка возможных значений. */
const valuesToString = (values) => {
  if (Array.isArray(values))
    return (values.length>0)?values[0].object.value:"";
  return values;
}

/** Форма редактирования литерала без учёта языка */
class LiteralSimpleEditor extends React.Component {

  state = {
    loading: false,
    operation: "none",		//Состояние операции. none - нет операций, 
      //edit - режим редактирования
      //save - режим сохранения,
      //cancel - режим отмены сохранения,
    }
  
  formRef = React.createRef();

  componentWillReceiveProps(nextProps){
    const { opertaion } = this.state;
    const { selected, predicat } = nextProps;
    if ( opertaion != "none" && selected && selected != predicat) 
      this.setState({operation: "none"});
  };

  cancelOperation(){
    this.setState({operation:"none"});
  };

  onAction (e, type, value) {
    e.preventDefault();
    const { subject, action, predicat, onUpdateProperty, onDeleteProperty, onReload } = this.props;
    if (type == 'edit'){
      if (action)
        action(e, type, predicat);
      return this.setState({operation:"edit"});
    };
    if (type == "save"){
      const form  = this.formRef.current;      
      form.validateFields()
        .then( values => {
          const newValue = values[predicat];
          //Проверка для числа Number.isFinite(newValue);
          //console.log("LiteralSimpleEditor.js onAction", this, type, value, newValue, values);
          this.setState({operation:"none"});          
          onUpdateProperty(RdfTriplet, subject, predicat, value, valueToString(newValue))
          .then (result =>{
            //Обновим каталог
            if (onReload)
              onReload(subject, predicat).then(result2=> {
                this.setState({modal:"none"});
              });
            else{
              message.success("Для просмотра изменений перегрузите страницу.");
              this.setState({modal:"none"});
            };
          });
        });
    }; //endif if (type == "save"){
    if (type == "cancel"){
      return this.setState({operation:"none"});
    }
    if (type == "delete"){
      confirm(
        { 
          title: 'Удалить свойство', 
          content: "При удалении будут удалены все литеральные данные свойства", 
          okText: 'Да', 
          okType: 'danger', 
          cancelText: 'Нет',
          onOk() { 
            onDeleteProperty(RdfTriplet, subject, predicat)
            .then (result =>{
              // if (action) action(e, type, predicat);
              //Обновим каталог
              if (onReload)
                onReload(subject, predicat).then(result2=> {
                  //this.setState({modal:"none"});              
                });
              else{
                message.success("Для просмотра изменений перегрузите страницу.");
              };    
            })
            .catch(info => {
              message.error(i18n.t('components.editor.theme.message.e_unlink', {detail: info}));
              //this.setState({modal:"none"});
            });
                  },
          onCancel() {},
        });
        return;      
    }; //endif if (type == "delete"){
  };

  render() {
    const { lang, values, predicat, subject, factory } = this.props;
    const { operation } = this.state;
    const Component = operation == "edit"? factory.ui.getFormItem(predicat): factory.ui.getUIComponent(predicat);
    const value = valuesToString(values);
    //console.log(this, value, values);
    return (
      <span>
        <ButtonGroup>
          {operation == "none" && 
            <Tooltip placement="top" title={"Редактировать"}>
              <Button type="dashed" size="small" icon={<EditOutlined />} onClick={(e)=> this.onAction(e, "edit", values)} />
            </Tooltip>
          }
          {operation == "edit" && 
            <Tooltip placement="top" title={"Отменить"}>
              <Button type="dashed" size="small" icon={<CloseOutlined />} onClick={(e)=> this.onAction(e, "cancel")} />
            </Tooltip>
          }
          {operation == "edit" && 
            <Tooltip placement="top" title={"Сохранить"}>
              <Button type="dashed" size="small" icon={<CheckOutlined />} onClick={(e)=> this.onAction(e, "save", value)} />
            </Tooltip>
          }
        </ButtonGroup>
        {operation == "edit" &&       
          <Tooltip placement="top" title={"Удалить свойство"}>
            <Button type="dashed" size="small" icon={<MinusCircleOutlined />} 
              onClick={(e)=> this.onAction(e, "delete")}
              style={{"float":"right"}}/>
          </Tooltip>
        }
        <br />
        {operation == "none" && 
          <Component 
          lang={lang} 
          subject={subject} 
          predicat={predicat} 
          uri={predicat} 
          values={values} 
          factory={factory} 
          />
        }
        {operation == "edit" && 
          <Form ref={this.formRef}>
            <Component 
              lang={lang} 
              subject={subject} 
              predicat={predicat} 
              uri={predicat} 
              value={value} 
              factory={factory} 
              hideLabel={true}
              />
          </Form>
        }
      </span>
    );
  };  
};

function mapStateToProps(state, props) {
  const {vselected} = state;
  return {
      vselected
  };
}

export default connect(
  mapStateToProps,
  dispatch => ({
    onUpdateProperty(actions, subject, predicat, oldValue, newValue){
      return dispatch(actions.updateLiteralSimple(subject, predicat, oldValue, newValue));
    },
    onDeleteProperty(actions, subject, predicat){
      return dispatch(actions.deletePredicate(subject, predicat));
    },
    onRealod(actions){
      return dispatch(actions.loadCatalogDetails());
    },
  })
)(LiteralSimpleEditor);